import * as THREE from 'three';

import { getCamera } from '../../modules/player';
import { get as sceneGet, set as sceneSet, getWorldTransform } from '../../modules/scene';
import { merge, vrCameraId, get, set, virtualTargetId } from '../../modules/sceneGraph';
import decompose from './decompose';
import getTargetWorldMatrix from './getTargetWorldMatrix';

import VRControls from './vrControls';

export default function enableDeviceTracking(store, externals) {
  const dummyCamera = new THREE.Camera();
  let vrControls = new VRControls(dummyCamera);
  externals.vrControls = externals;


  function orientHandle () {
    if(vrControls) vrControls.update();
    dummyCamera.updateMatrix();
    matchToCamera(dummyCamera);
  }


  function matchToCamera(threeCamera){
    const cameraId = getCamera(store);
    const targetWorldMatrix = getTargetWorldMatrix(store);
    const targetPosition = new THREE.Vector3().setFromMatrixPosition(targetWorldMatrix);

    const length = targetPosition.sub(threeCamera.position).length();
    targetPosition.set(0,0,-length).applyQuaternion(threeCamera.quaternion).add(threeCamera.position);
    const upPosition = new THREE.Vector3(0,1,0).applyQuaternion(threeCamera.quaternion);

    targetWorldMatrix.setPosition(targetPosition);
    const camData = sceneGet(store, {id:cameraId, evalPlug:'Camera'})
    camData.upPosition = upPosition;
    store.dispatch(set(
      [cameraId, 'Transform',0, 'rotation'],
      decompose(threeCamera.matrix.clone()).rotation
    ));
    if (!sceneGet(store, { id: cameraId, evalPlug: 'Transform' }).target) {
      store.dispatch(merge([virtualTargetId, 'Transform', 0], decompose(targetWorldMatrix)));
    }
  }

  if(__BROWSER__) window.addEventListener('deviceorientation', orientHandle);
  return orientHandle;
}



// WEBPACK FOOTER //
// ./src/translators/utils/deviceTracking.js